module.exports = __webpack_public_path__ + "media/images/icons/filled/file-383545a9834631372035a02736372456.svg";